var map = {
	"./assets/NoMarketingCookie.png": "fd8d",
	"./assets/academy/academy.svg": "10d2c",
	"./assets/academy/demo-tool.gif": "313d",
	"./assets/academy/videos/1.png": "7f56",
	"./assets/academy/videos/2.png": "56fd",
	"./assets/academy/videos/3.png": "62f6",
	"./assets/academy/videos/4.png": "3e72",
	"./assets/academy/videos/5.png": "f662",
	"./assets/academy/videos/Fake_Video-1.jpg": "7473",
	"./assets/academy/videos/Fake_Video-2.jpg": "e6d6",
	"./assets/academy/videos/Fake_Video-3.jpg": "68b1",
	"./assets/academy/videos/Fake_Video-4.jpg": "a154",
	"./assets/academy/videos/Fake_Video-5.jpg": "097f",
	"./assets/academy/videos/Fake_Video-6.jpg": "fd5d",
	"./assets/academy/videos/Fake_Video-7.jpg": "2611",
	"./assets/academy/videos/Fake_Video-8.jpg": "0b0c",
	"./assets/academy/videos/Fake_Video-9.jpg": "5be3",
	"./assets/archetypes/anchor": "4ac2",
	"./assets/archetypes/anchor.json": "4ac2",
	"./assets/archetypes/anchor.svg": "bdc6",
	"./assets/archetypes/authentic": "e118",
	"./assets/archetypes/authentic.json": "e118",
	"./assets/archetypes/authentic.svg": "e428",
	"./assets/archetypes/background/scene-anchor.svg": "8b71",
	"./assets/archetypes/background/scene-authentic.svg": "e312",
	"./assets/archetypes/background/scene-challenger.svg": "98b3",
	"./assets/archetypes/background/scene-coordinator.svg": "28fb",
	"./assets/archetypes/background/scene-creator.svg": "f4e3",
	"./assets/archetypes/background/scene-defender.svg": "2331",
	"./assets/archetypes/background/scene-diplomat.svg": "8653",
	"./assets/archetypes/background/scene-individual.svg": "2d89",
	"./assets/archetypes/background/scene-pioneer.svg": "2c8a",
	"./assets/archetypes/background/scene-problemsolver.svg": "7a9e",
	"./assets/archetypes/background/scene-pulsegenerator.svg": "2255",
	"./assets/archetypes/background/scene-rockstar.svg": "2763",
	"./assets/archetypes/challenger": "595d",
	"./assets/archetypes/challenger.json": "595d",
	"./assets/archetypes/challenger.svg": "09d3",
	"./assets/archetypes/coordinator": "d8c1",
	"./assets/archetypes/coordinator.json": "d8c1",
	"./assets/archetypes/coordinator.svg": "c2d8",
	"./assets/archetypes/creator": "7712",
	"./assets/archetypes/creator.json": "7712",
	"./assets/archetypes/creator.svg": "b185",
	"./assets/archetypes/defender": "140b",
	"./assets/archetypes/defender.json": "140b",
	"./assets/archetypes/defender.svg": "f805",
	"./assets/archetypes/diplomat": "f0f6",
	"./assets/archetypes/diplomat.json": "f0f6",
	"./assets/archetypes/diplomat.svg": "81fd",
	"./assets/archetypes/individual.svg": "0b80",
	"./assets/archetypes/pioneer": "dc35",
	"./assets/archetypes/pioneer.json": "dc35",
	"./assets/archetypes/pioneer.svg": "5119",
	"./assets/archetypes/problemsolver": "859d",
	"./assets/archetypes/problemsolver.json": "859d",
	"./assets/archetypes/problemsolver.svg": "f367",
	"./assets/archetypes/pulsegenerator": "dc6e",
	"./assets/archetypes/pulsegenerator.json": "dc6e",
	"./assets/archetypes/pulsegenerator.svg": "fb53",
	"./assets/archetypes/rockstar": "11cb",
	"./assets/archetypes/rockstar.json": "11cb",
	"./assets/archetypes/rockstar.svg": "19ec",
	"./assets/brokerage/finCraft_Broker_Illustration-17.png": "6fc1",
	"./assets/error/page-not-found.svg": "a0cf",
	"./assets/error/success.png": "2815",
	"./assets/error/warning.png": "6d0f",
	"./assets/finCommunity/community-people.svg": "2e11",
	"./assets/finCommunity/new-post.svg": "c226",
	"./assets/finStrategy/archetype-selected.svg": "db1a",
	"./assets/finStrategy/etfs.svg": "f22b",
	"./assets/finStrategy/fin-strategie.svg": "521d",
	"./assets/finStrategy/finfinder.svg": "e362",
	"./assets/finStrategy/goals.svg": "6bfc",
	"./assets/finStrategy/screener.svg": "3220",
	"./assets/finStrategy/shares.svg": "4ec4",
	"./assets/impressum/citi_logo.png": "a152",
	"./assets/impressum/factset_logo.png": "33a6",
	"./assets/impressum/infront_logo.jpg": "bf20",
	"./assets/impressum/tradegate_logo.png": "6aa6",
	"./assets/lexicon/lexicon.svg": "deec",
	"./assets/loading.png": "4b50",
	"./assets/myFinHub/fin-academy-e-learning.svg": "7820",
	"./assets/myFinHub/fin-academy-library.svg": "e579",
	"./assets/myFinHub/fin-academy-manual.svg": "2153",
	"./assets/myFinHub/fin-new-watchlist.svg": "de42",
	"./assets/myFinHub/page-header-background-chart.svg": "23f8",
	"./assets/myFinHub/page-header-background-circle.svg": "b4fe",
	"./assets/myFinHub/page-header-background-pie.svg": "02d1",
	"./assets/myFinHub/tool-news.svg": "ced5",
	"./assets/onboarding/choose-archetype.svg": "443f",
	"./assets/onboarding/duration.svg": "f7c9",
	"./assets/onboarding/fastTrack/card1.png": "d800",
	"./assets/onboarding/fastTrack/card2.png": "d484",
	"./assets/onboarding/getstarted/final-portfolio.svg": "49bf",
	"./assets/onboarding/know-how.svg": "e299",
	"./assets/onboarding/onboarding_preview_img.jpg": "806a",
	"./assets/onboarding/personalize.svg": "43621",
	"./assets/onboarding/portfolio/onboarding-portfolio-final.svg": "e918",
	"./assets/onboarding/registration/email-confirmation-error.svg": "6726",
	"./assets/onboarding/registration/email-confirmation-successful.svg": "cdca",
	"./assets/onboarding/registration/email-confirmation.svg": "b26c",
	"./assets/onboarding/risk.svg": "5155",
	"./assets/onboarding/step-by-step.svg": "f394",
	"./assets/onboarding/stepByStep/step1/chicken1": "f8b2",
	"./assets/onboarding/stepByStep/step1/chicken1.json": "f8b2",
	"./assets/onboarding/stepByStep/step1/chicken2": "f9ae",
	"./assets/onboarding/stepByStep/step1/chicken2.json": "f9ae",
	"./assets/onboarding/stepByStep/step1/chicken3": "a41a",
	"./assets/onboarding/stepByStep/step1/chicken3.json": "a41a",
	"./assets/onboarding/stepByStep/step2/tree1": "7a30",
	"./assets/onboarding/stepByStep/step2/tree1.json": "7a30",
	"./assets/onboarding/stepByStep/step2/tree2": "ad0b",
	"./assets/onboarding/stepByStep/step2/tree2.json": "ad0b",
	"./assets/onboarding/stepByStep/step2/tree3": "ea84",
	"./assets/onboarding/stepByStep/step2/tree3.json": "ea84",
	"./assets/onboarding/stepByStep/step3/dog": "c09b",
	"./assets/onboarding/stepByStep/step3/dog.json": "c09b",
	"./assets/onboarding/stepByStep/step3/mouse": "2251",
	"./assets/onboarding/stepByStep/step3/mouse.json": "2251",
	"./assets/onboarding/stepByStep/step3/tiger": "d028",
	"./assets/onboarding/stepByStep/step3/tiger.json": "d028",
	"./assets/onboarding/stepByStep/step4/level1": "8be3",
	"./assets/onboarding/stepByStep/step4/level1.json": "8be3",
	"./assets/onboarding/stepByStep/step4/level2": "0032",
	"./assets/onboarding/stepByStep/step4/level2.json": "0032",
	"./assets/onboarding/stepByStep/step4/level3": "a08a",
	"./assets/onboarding/stepByStep/step4/level3.json": "a08a",
	"./assets/onboarding/stepByStep/step5/chair1": "aa81",
	"./assets/onboarding/stepByStep/step5/chair1.json": "aa81",
	"./assets/onboarding/stepByStep/step5/chair2": "d8df",
	"./assets/onboarding/stepByStep/step5/chair2.json": "d8df",
	"./assets/onboarding/stepByStep/step5/chair3": "ab8a",
	"./assets/onboarding/stepByStep/step5/chair3.json": "ab8a",
	"./assets/onboarding/stepByStep/step6/fisherman1": "a276",
	"./assets/onboarding/stepByStep/step6/fisherman1.json": "a276",
	"./assets/onboarding/stepByStep/step6/fisherman2": "0fa5",
	"./assets/onboarding/stepByStep/step6/fisherman2.json": "0fa5",
	"./assets/onboarding/stepByStep/step6/fisherman3": "eb00",
	"./assets/onboarding/stepByStep/step6/fisherman3.json": "eb00",
	"./assets/onboarding/strategy/asset-verteilung.svg": "9e42",
	"./assets/onboarding/strategy/custom-invest.svg": "d127",
	"./assets/onboarding/strategy/herausforderung_1024.svg": "bbe7",
	"./assets/onboarding/strategy/huge-invest.svg": "23a9",
	"./assets/onboarding/strategy/initial-strategy.png": "b236",
	"./assets/onboarding/strategy/medium-invest.svg": "8481",
	"./assets/onboarding/strategy/small-invest.svg": "b8db",
	"./assets/onboarding/time.svg": "f8a2",
	"./assets/onboarding/transaction.svg": "2cca",
	"./assets/profile/anonymous-avatar.png": "e545",
	"./assets/registration/registration-background.svg": "dcc0",
	"./assets/registration/welcome.svg": "5ee8",
	"./assets/subscription/upgrade.svg": "b81f",
	"./assets/tools/rate/shares/rate-share.svg": "c10e",
	"./assets/tools/screener-card.svg": "fb0e",
	"./assets/tools/screener-copy.svg": "0bd2",
	"./assets/tools/tool-empty-state.svg": "5caf",
	"./assets/tools/tool-toolbox.svg": "f393",
	"./assets/tools/tool-tools-portfolio.svg": "90e5",
	"./assets/watchlist/watchlist.svg": "2f35",
	"./assets/workInProgress/coming-soon.svg": "1cf3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53a4";